// extracted by mini-css-extract-plugin
var _1 = "jt55H";
var _2 = "ulwJg";
export { _1 as "externalLink", _2 as "externalLinkIcon" }
